import { render, staticRenderFns } from "./detail_config_dataset_edit.vue?vue&type=template&id=492c17c8"
import script from "./detail_config_dataset_edit.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_edit.vue?vue&type=script&lang=js"
import style0 from "./detail_config_dataset_edit.vue?vue&type=style&index=0&id=492c17c8&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492c17c8')) {
      api.createRecord('492c17c8', component.options)
    } else {
      api.reload('492c17c8', component.options)
    }
    module.hot.accept("./detail_config_dataset_edit.vue?vue&type=template&id=492c17c8", function () {
      api.rerender('492c17c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config_dataset_edit.vue"
export default component.exports